<!-- eslint-disable vue/prop-name-casing -->
<script setup>
import { inject, onMounted } from 'vue'
import { useRouter } from 'vue-router';
import { AirwallexClass } from './index'

const Airwallex = new AirwallexClass()

const router = useRouter()

const props = defineProps({
  intent_id: {
    type: String,
    default: ''
  },
  client_secret: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: ''
  },
})

const emit = defineEmits(['completed'])

const ProvideIsJump = inject('ProvideIsJump')

const onSuccess = () => {
  /**
   * ... Handle events on success
   */
  emit('completed')
}
const closeDestory = () =>  {
  Airwallex.cancelFunction()
}

onMounted(() => {
  Airwallex.onSuccess = onSuccess
  Airwallex.loadFunction(
    props.type,
    props.intent_id,
    props.client_secret
  )
//   setTimeout(() => {
//     onSuccess()
//   }, 5000);
})

defineExpose({
  closeDestory
})

</script>
<template>
  <div>
    <div id="dropIn" />
  </div>
</template>
<style lang="scss" scoped>
</style>